<template>
    <nav class="navbar clsnavbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow headNavCls">
        <h2 class="pageTitleCls">
            <a href="javascript:void(0);" class="sidebar-toggle" @click="sidebarToggle">
                <i class="hamburger"></i>
            </a>
            <ul>
                <li>
                    <span>{{ $store.state.pageTitle }}</span>
                </li>
            </ul>  
        </h2>
    </nav>
    <div class="modal fade confirmationset" id="logoutModals" tabindex="-1" style="display: none;" aria-hidden="true"  data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="staticBackdropLabel">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
            <div class="modal-header justify-content-center">
                <h5 class="modal-title">Confirm Change?</h5> 
            </div>
            <div class="modal-body"> 
                <div class="col-12 text-center"> 
                <label for="bankName" class="form-label mb-0">Are you sure you want to logout?</label> 
                </div>
            </div>
            <div class="modal-footer justify-content-center d-flex">
                <button variant="success"  class="mg-btn-gold h-30 me-2" v-on:click="logout()">Yes</Button> 
                <button variant="outline-primary" class="mg-btn-delete-lightx h-30 md" id="closeBtn" data-bs-dismiss="modal" >No</Button>         
            </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
    export default {
        name: 'HeaderAdminPage',
        async mounted() { 
            // alert('1.1.1')
        },
        methods: {
            async sidebarToggle() {
                $('.main_rightcontent').toggleClass('sideMenuActive')
            },
            async logout() {
                document.getElementById('closeBtn').click();
                this.$store.state.user.accessToken = ''
                this.$store.state.isActiveToken = ''
                this.$store.state.user.userInfo = ''
                this.$store.state.isAdmin = 2 
                localStorage.removeItem("supportSystemAdmin");
                this.$router.push({
                    path: '/login'
                })
            },
        },
    }
</script>